// import { useNavigate } from 'react-router-dom';

// import { Box, Text, Heading, Grid, Stack,Button, Icon, Flex, Image } from "@chakra-ui/react";
// import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
// import ico from '../../images/company logo.jpg'
// import { ArrowBackIcon } from '@chakra-ui/icons';
// import { Link } from 'react-router-dom';

// const About = () => {
//   const navigate = useNavigate();

//   return (

//     <Box position="relative" minHeight="100vh"  bg="gray.50" >
//       {/* <Button
//         backgroundColor="white"
//         boxShadow="md"
//         fontSize="11px"
//         color="#515B73"
//         position="absolute"
//         top="10px"
//         left="2%"
//         onClick={() => navigate(-1)}
//       >
//           <ArrowBackIcon />

//       </Button> */}
//             <div className="teacher-list-container">
//         <div className="header">
//           <h1 fontSize="20px">About Us</h1>
//           <div className="action-buttons">

//           </div>
//         </div>
//         <div className="breadcrumb">
//         <Link to="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
//         <span>Dashboard</span>
//     </Link>  / <span>About Us</span>
//         </div>

//     <Flex  align="center" justify="center" bg="gray.50" p={16}>

//       <Box p={8} maxW="800px" mx="auto" bg="white" borderRadius="lg" borderWidth="1px" boxShadow="lg">

//         <Flex justify="center" mb={6}>

//           <Image src={ico} alt="Buzcatch Logo" boxSize="100px" objectFit="contain" />
//         </Flex>
//         <Heading as="h1" size="2xl" mb={6} textAlign="center" color="teal.600">
//           About Us
//         </Heading>
//         <Text fontSize="lg" mb={4} color="gray.700" lineHeight="1.7">
//           Buzcatch Pvt Ltd, founded in 2022, is a leading IT solutions company based in Kerala, India.
//           With a mission to empower businesses through innovative technology, Buzcatch offers a wide
//           range of services, including custom software development, mobile app solutions, web development,
//           and digital marketing.
//         </Text>

//         <Grid templateColumns="repeat(2, 1fr)" gap={6} mt={8}>
//           <Box bg="teal.100" p={6} rounded="md" boxShadow="md">
//             <Text fontWeight="bold" color="teal.700">Founded</Text>
//             <Text>2022</Text>
//             <Text fontWeight="bold" color="teal.700">Clients</Text>
//             <Text>150+</Text>
//           </Box>
//           <Box bg="teal.100" p={6} rounded="md" boxShadow="md">
//             <Text fontWeight="bold" color="teal.700">Services</Text>
//             <Text>Software Development, Web Development, Mobile App Solutions, Digital Marketing</Text>
//           </Box>
//         </Grid>

//         <Box mt={8}>
//           <Heading as="h2" size="lg" mb={4} color="teal.600">
//             Contact Us
//           </Heading>
//           <Stack spacing={3}>
//             <Stack direction="row" align="center">
//               <Icon as={FaEnvelope} color="teal.500" />
//               <Text fontSize="md">info@buzcatch.com</Text>
//             </Stack>
//             <Stack direction="row" align="center">
//               <Icon as={FaPhone} color="teal.500" />
//               <Text fontSize="md">+91 9526 72 73 16</Text>
//             </Stack>
//             <Stack direction="row" align="center">
//               <Icon as={FaMapMarkerAlt} color="teal.500" />
//               <Text fontSize="md">Integrated Startup Complex, Kalamassery, Cochin, India</Text>
//             </Stack>
//           </Stack>
//         </Box>
//       </Box>

//     </Flex>
//     </div>
//     </Box>
//   );
// };

// export default About;

import { useNavigate, Link } from "react-router-dom";
import {
  Box,
  Text,
  Heading,
  Grid,
  Stack,
  Icon,
  Flex,
  Image,
  SimpleGrid, // Added for responsive grid layouts
  Divider, // Added for separation
  useBreakpointValue, // Added for responsive styles
} from "@chakra-ui/react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaGlobe } from "react-icons/fa"; // Added FaGlobe for a touch of detail
import ico from "../../images/company logo.jpg"; // Assuming this path is correct
import { BiPhone } from "react-icons/bi";

// Use a custom color object for better theming (optional, but good practice)
const primaryColor = "blue.600";
const secondaryColor = "blue.50";

const About = () => {
  const navigate = useNavigate();

  // Responsive padding for the main content box
  const boxPadding = useBreakpointValue({ base: 4, md: 8, lg: 10 });

  // Responsive column count for the info grid
  const gridColumns = useBreakpointValue({ base: 1, md: 2 });

  return (
    <Box position="relative" minHeight="100vh" bg="gray.50">
      {/* --- Breadcrumb and Header Section (Refined) --- */}
      <Box
        px={boxPadding}
        pt={4}
        pb={2}
        // borderBottom="1px"
        // borderColor="gray.200"
        bg="gray.50"
      >
        <Flex justify="space-between" align="center">
          <Heading as="h1" size="20" color="gray.800">
            About Us
          </Heading>
        </Flex>
        <Text fontSize="sm" color="gray.500" mt={1}>
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Text as="span" _hover={{ color: primaryColor }} transition="0.2s">
              Dashboard
            </Text>
          </Link>
          <Text as="span" mx={1}>
            /
          </Text>
          <Text as="span" fontWeight="semibold">
            About Us
          </Text>
        </Text>
      </Box>

      {/* --- Main Content Container --- */}
      <Flex
        align="flex-start"
        justify="center"
        p={boxPadding}
        minH="calc(100vh - 70px)"
      >
        {" "}
        {/* Adjust minH based on header height */}
        <Box
          p={boxPadding}
          maxW="900px"
          w="full"
          bg="white"
          borderRadius="xl" // Larger border radius
          boxShadow="2xl" // More prominent shadow
        >
          {/* --- Logo and Main Heading --- */}
          <Stack spacing={6} align="center" pb={6}>
            <Image
              src={ico}
              alt="Buzcatch Logo"
              boxSize="120px"
              objectFit="contain"
              borderRadius="full"
              border="4px solid"
              borderColor={primaryColor}
              p={1}
            />
            <Heading as="h1" size="2xl" color={primaryColor} textAlign="center">
              Buzcatch Pvt Ltd
            </Heading>
          </Stack>

          <Divider mb={8} borderColor="gray.200" />

          {/* --- Mission/Description Text --- */}
          <Box mb={10}>
            <Heading
              as="h2"
              size="xl"
              mb={4}
              color="gray.700"
              fontWeight="bold"
              textAlign="center"
            >
              Our Mission
            </Heading>
            <Text
              fontSize="lg"
              color="gray.600"
              lineHeight="tall"
              textAlign="center"
            >
              Buzcatch Pvt Ltd, founded in 2022, is a leading IT solutions
              company based in Kerala, India. With a mission to empower
              businesses through innovative technology, Buzcatch offers a wide
              range of services, including custom software development, mobile
              app solutions, web development, and digital marketing. We focus on
              delivering high-impact, scalable, and user-friendly digital
              solutions.
            </Text>
          </Box>

          {/* --- Stats/Services Grid (Responsive) --- */}
          <SimpleGrid columns={gridColumns} spacing={6} mt={8}>
            <StatCard title="Founded" value="2022" icon={FaGlobe} />
            <StatCard title="Clients Served" value="150+" icon={FaGlobe} />
            <StatCard
              title="Key Services"
              value="Software, Web & Mobile App Development, Digital Marketing"
              icon={FaGlobe}
              isMultiLine
            />
            <StatCard
              title="Location"
              value="Kerala, India"
              icon={FaMapMarkerAlt}
            />
          </SimpleGrid>

          <Divider my={10} borderColor="gray.200" />

          {/* --- Contact Information --- */}
          <Box>
            <Heading as="h2" size="xl" mb={6} color={primaryColor}>
              Get In Touch
            </Heading>
            <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={8}>
              <ContactItem
                icon={FaEnvelope}
                title="Email"
                value="info@buzcatch.com"
                link="mailto:info@buzcatch.com"
              />

              <ContactItem
                icon={BiPhone}
                title="Phone"
                value="+91 9526 72 73 16"
                link="tel:+919526727316"
              />

              <ContactItem
                icon={FaMapMarkerAlt}
                title="Address"
                value="Integrated Startup Complex, Kalamassery, Cochin, India"
                isAddress
              />
            </SimpleGrid>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

// --- Helper Components for Clean Code ---

// Component for the stat boxes
const StatCard = ({ title, value, icon, isMultiLine = false }) => (
  <Box bg={secondaryColor} p={6} rounded="xl" boxShadow="lg">
    <Flex align="center" mb={2}>
      <Icon as={icon} w={6} h={6} color={primaryColor} mr={3} />
      <Text fontWeight="bold" fontSize="lg" color={primaryColor}>
        {title}
      </Text>
    </Flex>
    <Text
      fontSize={isMultiLine ? "md" : "xl"}
      color="gray.700"
      fontWeight={isMultiLine ? "normal" : "semibold"}
    >
      {value}
    </Text>
  </Box>
);

// Component for the contact items
const ContactItem = ({ icon, title, value, link, isAddress = false }) => (
  <Stack
    spacing={2}
    p={4}
    rounded="lg"
    borderWidth="1px"
    borderColor="gray.200"
    _hover={{ borderColor: primaryColor, boxShadow: "md" }}
    transition="0.2s"
  >
    <Flex align="center">
      <Icon as={icon} w={6} h={6} color={primaryColor} mr={3} />
      <Text fontWeight="bold" fontSize="lg" color="gray.700">
        {title}
      </Text>
    </Flex>
    {isAddress ? (
      <Text fontSize="md" color="gray.600">
        {value}
      </Text>
    ) : (
      <Link href={link} style={{ textDecoration: "none" }} isExternal>
        <Text
          fontSize="md"
          color={primaryColor}
          _hover={{ textDecoration: "underline" }}
        >
          {value}
        </Text>
      </Link>
    )}
  </Stack>
);

export default About;
